import { Component } from "react";
//Import Components
import MainPagetitle from "../../layouts/MainPagetitle";
import DigirepInfo from "./DashboardHelpers/DigirepInfo/DigirepInfo";
import LeadInfo from "./DashboardHelpers/LeadInfo/LeadInfo";
import PaymentInfo from "./DashboardHelpers/PaymentInfo/PaymentInfo";
import ProductwisePortfolio from "./DashboardHelpers/ProductwisePortfolio/ProductwisePortfolio";
import StateInfoMap from "./DashboardHelpers/StateInfoMap/StateInfoMap";
import OverallPortfolioCard from "./OverallPortfolioCard";
import SalesInfo from "./DashboardHelpers/SalesInfo/SalesInfo";

class Home extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)();
    this.state = {
      b2b: [],
      b2c: [],
      productTypes: [],
      activeKey: "portfolio_info",
    };
    this.filterTabData = [
      {
        key: "portfolio_info",
        name: "Portfolio Info.",
      },
      {
        key: "product_info",
        name: "Product Info.",
      },
      {
        key: "state_info",
        name: "State Info.",
      },
    ];
  }

  handleSelect(e, key) {
    this.setState({
      activeKey: key,
    });
  }

  // ----------------------------------------------------------------

  componentDidMount() {
    this.setState({ isClient: true });
    this.props.store("mounted", true);
    this.services
      .checkAuthorize(this.props, "admin")
      .then(() => {
        this.services.checkExpiry();
      })
      .catch((err) => {});
    console.log("Home", this.props);
  }

  render() {
    let { columns } = this;
    let { b2b, b2c, productTypes, activeKey, stateMapData } = this.state;

    return (
      <>
        <MainPagetitle
          mainTitle="Dashboard"
          pageTitle="Dashboard"
          parentTitle="Home"
          pageIcon={imagepaths.DashboardActive}
        />
        <div className="container-fluid">
          <div className="container dashboard_outer">
            <OverallPortfolioCard />
            <PaymentInfo />
            <SalesInfo />
          </div>
        </div>
      </>
    );
  }
}
export default constore(Home);
